import styled from 'styled-components';

const ProductItemPriceContainer = styled.div`
    align-items: flex-start;
    display: flex;
`;

export default ProductItemPriceContainer;
